
import '../static/js/common.js'
import Loading from 'vux/src/components/loading/index.vue'


export default {
name: 'App',
components: {
Loading,
},
mounted() {

},
methods: {
saveState() {
var _this = this
sessionStorage.setItem('state', JSON.stringify(this.$store.state))
},

}

}



// WEBPACK FOOTER //
// ./src/App.vue